import { render, staticRenderFns } from "./DevolucionDocumentosBusqueda.vue?vue&type=template&id=f0759f28&scoped=true"
import script from "./DevolucionDocumentosBusqueda.vue?vue&type=script&lang=js"
export * from "./DevolucionDocumentosBusqueda.vue?vue&type=script&lang=js"
import style0 from "./DevolucionDocumentosBusqueda.vue?vue&type=style&index=0&id=f0759f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0759f28",
  null
  
)

export default component.exports